<div class="sh-page-template__main__content">
  <div class="sh-template-stack">
    <sh-page-header class="sh-template-stack__item" [title]="'reports.title' | translate"></sh-page-header>

    @if (reports$ | async; as reports) {
      <sh-display-settings-bar
        [showSortSelect]="false"
        [showViewToggle]="false"
        [sortPrefixMessage]="'sort.prefix' | translate"
        [sortLoadingMsg]="'general.filter.loading' | translate"
        [xxResultsLabelKey]="'general.xx-results.report'"
        [noResultsLabelKey]="'general.no-results.report'"
        [totalResults]="(error$ | async) ? 0 : reports.results.length"
        >
      </sh-display-settings-bar>
    }
    <div class="sh-template-stack__item">
      <div class="sh-card-table-wrapper">
        <table class="sh-card-table" id="reports-overview">
          <thead>
            <tr>
              <th scope="col" width="600">{{ "reports.table.columns.name" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @if (loading$ | async) {
              <tr>
                <td [colSpan]="COLUMN_COUNT">{{ "ui.loading" | translate }}</td>
              </tr>
            }

            @if (!(loading$ | async) && !(error$ | async) && (reports$ | async)?.results.length === 0) {
              <tr>
                <td [colSpan]="COLUMN_COUNT">{{ "reports.messages.empty-list" | translate }}</td>
              </tr>
            }

            @if (error$ | async) {
              <tr class="sh-card-table__row--error">
                <td [colSpan]="COLUMN_COUNT">{{ "reports.messages.failed-to-fetch" | translate }}</td>
              </tr>
            }

            @if (!(loading$ | async) && !(error$ | async) && (reports$ | async)?.results.length > 0) {
              @for (report of (reports$ | async)?.results; track report) {
                <tr>
                  <th scope="row" [id]="report.Id">
                    <a [routerLink]="report.Id" class="sh-list-row-title">
                      <h3 class="sh-list-row-title__title -sh-wrap">{{ report.Label }}</h3>
                    </a>
                  </th>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
    <sh-pagination
      [paginationInfo]="paginationInfo$ | async"
      [previousPageMsg]="'components.pagination.previous' | translate"
      [nextPageMsg]="'components.pagination.next' | translate"
      (paginationInfoChanged)="onPaginationInfoChanged($event)"
      >
    </sh-pagination>
  </div>
</div>
